
<template>
    <nav class="page-nav" aria-label="Navigation">
        <div v-for="(item, index) in contentData" :key="index" class="page-nav__item">
            <router-link
                :to="'/' + index + '/'"
                class="page-nav__item-link">
                {{ item.title }}
            </router-link>
        </div>
    </nav>
</template>

<script>
export default {
    props: {
        contentData: Object,
    },
};
</script>

<style lang="scss">
    .page-nav {
        display: flex;
        margin-bottom: 3rem;
        flex-direction: column;

        @include mq($from: md) {
            flex-direction: row;
            margin-bottom: 7rem;
        }

        @include mq($from: lg) {
            margin-bottom: 8rem;
        }
    }

    .page-nav__item {
        margin: 0 0 1.5rem 0;

        &:last-of-type {
            margin: 0;
        }

        @include mq($from: md) {
            margin: 0 3rem 0 0;

            &:last-of-type {
                margin: 0;
            }
        }
    }

    .page-nav__item-link {
        display: inline-block;
        padding: 0.5rem 0;
        border: 0;
        border-bottom: solid 0.3rem white;
        font-size: 2rem;
        line-height: 1;
        font-weight: bold;
        text-decoration: none;
        transition: border-bottom-color $default-transition-duration $default-transition-style,
                    color $default-transition-duration $default-transition-style;

        @include mq($from: md) {
            font-size: 2.4rem;
        }

        @include mq($from: lg) {
            font-size: 2.5rem;
        }

        &:hover {
            border-bottom-color: $color-primary;
        }

        // Active item style
        &.router-link-active {
            border-bottom-color: $color-primary;
        }
    }
</style>
